/** @format */

import angular from 'angular';

import { AuctionModelsModule } from 'crowdcomms-js/lib/galabid/auction/models';
import { ItemModelsModule } from 'crowdcomms-js/lib/galabid/item/models';
import { RaffleModelsModule } from 'crowdcomms-js/lib/galabid/raffle/models';
import { ProjectorModelsModule } from 'crowdcomms-js/lib/galabid/projector/models';

import { GbSyncAuctionDataService } from './gb-sync-auction-data/gb-sync-auction-data.service.js';

export const ServicesModule = angular
    .module('galabid-presenter.shared.services', [
        AuctionModelsModule,
        ItemModelsModule,
        RaffleModelsModule,
        ProjectorModelsModule,
    ])
    .service('$gbSyncAuctionData', GbSyncAuctionDataService).name;
